module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New mortgage"},"et":{"title":"New mortgage"},"ru":{"title":"New mortgage"}}')
  delete Component.options._Ctor
}
